import React from 'react'

interface IProps extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  imageName: string // TODO: images/normal以下にあるファイル名を入力（例: logo.png）
}

export const Image = (props: IProps) => {
  return (
    <picture>
      <source srcSet={`./images/webp/${props.imageName}.webp`} type="image/webp" />
      <img {...props} src={`./images/normal/${props.imageName}`} alt={props.alt} />
    </picture>
  )
}